import { render, staticRenderFns } from "./CreateRejected.vue?vue&type=template&id=a9dae286&lang=html"
import script from "./CreateRejected.vue?vue&type=script&lang=js"
export * from "./CreateRejected.vue?vue&type=script&lang=js"
import style0 from "./CreateRejected.vue?vue&type=style&index=0&id=a9dae286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports